




import { Component, Vue } from 'vue-property-decorator';
import { ConstantsModuleMapper } from '@/store/modules/constants';

const Mappers = Vue.extend({
  computed: {
    ...ConstantsModuleMapper.mapGetters(['zadarmaCallBackDictionary']),
  },
});

@Component
export default class ZadarmaCallback extends Mappers {
  mounted() {
    const trigger = document.querySelector('#zadarmaCallBack');
    if (trigger) {
      window.ZCallbackWidgetLinkId = '3c549f4ee048f040a184a8b17e8d0b48';
      window.ZCallbackWidgetDomain = 'my.zadarma.com';

      const sWidget = document.createElement('script');
      sWidget.type = 'text/javascript';
      sWidget.async = true;
      sWidget.id = 'zadarmaCallback';
      sWidget.charset = 'utf-8';
      sWidget.src = `//${window.ZCallbackWidgetDomain}/callbackWidget/js/main.min.js?v=1.15.4`;
      const sc = document.getElementsByTagName('script')[0];
      if (sc && sc.parentNode) {
        sc.parentNode.insertBefore(sWidget, sc);
      } else if (document && document.documentElement) {
        document.documentElement.firstChild?.appendChild(sWidget);
      }
      trigger?.addEventListener('click', () => {
        const Widget = window.ZCallbackWidget;
        if (!Widget) {
          return;
        }
        const zadarmaCallBackDictionary = {} as Record<string, string>;
        Object
          .keys(this.zadarmaCallBackDictionary)
          .forEach((item: string, index, array: string[]) => {
            zadarmaCallBackDictionary[item] = this.$t(this.zadarmaCallBackDictionary[item], this.$i18n.locale) as string;
          });
        Widget.options.texts = {
          ...Widget.options.texts,
          ...zadarmaCallBackDictionary,
        };
        Widget.showCallback();
      });
    }
  }
}
